import React from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from './new/dropdown';
import Button from './new/button';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { fontList } from './fontList';

const fonts = fontList;

export type SAFonts = typeof fonts[number];

interface FontPickerProps {
  selectedFont: SAFonts;
  onSelectFont: (font: SAFonts) => void;
}
export default function FontPicker({
  selectedFont,
  onSelectFont
}: FontPickerProps) {
  return (
    <Dropdown
      className='w-[140px] bg-white'
      placement='bottom-start'
    >
      <DropdownTrigger>
        <Button
          kind='tertiary'
          size='sm'
          className='w-[140px]'
          endContent={<KeyboardArrowDownRoundedIcon fontSize='small'/>}
        >
          <p className='w-full text-start font-normal' >{selectedFont}</p>
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label='font-picker'
        onAction={(font) => onSelectFont(font as SAFonts)}
        className='max-h-[40vh] overflow-y-auto'
        disallowEmptySelection
        selectedKeys={[selectedFont]}
        selectionMode="single"
        variant="flat"
      >
        {fonts.map(font => <DropdownItem key={font} style={{ fontFamily: font }}>{font}</DropdownItem>)}
      </DropdownMenu>
    </Dropdown>
  );
}
